import { Box, alpha, styled } from '@mui/material';

export const ThemedWrapper = styled(Box, { shouldForwardProp: prop => prop !== 'color' })(({ theme, color = 'primary' }) => ({
  color: theme.palette[color].main,
  backgroundColor: alpha(theme.palette[color].main, 0.1),
  width: '100%',
  display: 'flex',
  paddingBlock: theme.spacing(1),
  paddingInline: theme.spacing(2),
  borderRadius: theme.spacing(1)
}));
